import React from 'react';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-white" data-id="element-80" data-mp="1i4znmpm6fims">
      <div className="mx-auto max-w-xl px-3 py-5 sm:px-4 sm:py-8" data-id="element-81" data-mp="4wb86lsv3lr6">
        <div className="rounded-2xl border-2 border-wifi bg-wifi-soft p-3.5 text-center" data-id="element-82" data-mp="9umiexn2jy9x">
          <p className="text-xs font-extrabold uppercase tracking-wide text-wifi sm:text-sm" data-id="element-83" data-mp="etfy8wptw1d9">
            Tu inversión está protegida
          </p>
          <h2 id="garantia" className="mt-0.5 font-display text-2xl uppercase text-navy sm:text-3xl" data-id="element-84" data-mp="jrr5czoqnxrs">
            🛡️ Garantía total de 7 días
          </h2>
          <p className="mt-1 text-[0.82rem] leading-snug text-negro/75 sm:text-sm" data-id="element-85" data-mp="sl48eugiofrl">
            Tienes 7 días para explorar los 6 tomos y los 5 bonos. Si consideras
            que el sistema no es adecuado para ti, puedes solicitar un reembolso
            dentro del período establecido según los términos de devolución.
          </p>
        </div>
      </div>
    </section>;
}